import { useMutation, useQueryClient } from "@tanstack/react-query";
import { sendPing } from "../api/send-ping";

export function usePing() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (message: string) => sendPing(message),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["health"] });
    },
  });
}
